<template>
  <v-overlay :class="$style.overlay"
             :value="showLoader"
             opacity="0.95">
    <v-progress-circular
      indeterminate
      color="#2C4F7A"
    ></v-progress-circular>
    <slot></slot>
  </v-overlay>
</template>

<script>
export default {
  props: {
    showLoader: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" module>
.overlay {
  margin-left: 250px;
}
</style>

<style lang="scss">
.v-overlay--active {
  /* Overriding Vuetify styles */
  pointer-events: auto !important;
}
</style>
